"use strict";

var _slicedToArray = require("/home/fugue/Dev/FF/impact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var single_1 = require("../single");
/**
 * Format matrix points to simple structure points
 * @param {string} params interpolation params
 * @param {string} points interpolation matrix
 * @return {array} formatted points
 */


exports.format = function (params, points) {
  if ('x' in params) {
    return [params.x, points.map(function (i) {
      return [i.x, i.y, i.z];
    })];
  }

  if ('y' in params) {
    return [params.y, points.map(function (i) {
      return [i.y, i.x, i.z];
    })];
  }

  throw new Error("Can't calculate double interpolation");
};
/**
 * Double interpolation store
 * @param {string} points interpolation matrix data
 * @return {void} interpolation execut method
 */


function double(points) {
  if (points.length <= 3) {
    throw new Error("Can't calculate double interpolation, please provide more points");
  }

  return function (params) {
    if ('x' in params && 'y' in params) {
      var sortX1 = function sortX1(a, b) {
        return b.x - a.x;
      };

      var findX1 = function findX1(i) {
        return i.x <= params.x;
      };

      var x1 = points.sort(sortX1).find(findX1);

      var sortX2 = function sortX2(a, b) {
        return a.x - b.x;
      };

      var findX2 = function findX2(i) {
        return i.x >= params.x;
      };

      var x2 = points.sort(sortX2).find(findX2);

      if (!x1 || !x2) {
        throw new Error("Can't calculate double interpolation for x: '".concat(params.x, "'"));
      }

      var sortY1 = function sortY1(a, b) {
        return b.y - a.y;
      };

      var findY1 = function findY1(i) {
        return i.y <= params.y;
      };

      var y1 = points.sort(sortY1).find(findY1);

      var sortY2 = function sortY2(a, b) {
        return a.y - b.y;
      };

      var findY2 = function findY2(i) {
        return i.y >= params.y;
      };

      var y2 = points.sort(sortY2).find(findY2);

      if (!y1 || !y2) {
        throw new Error("Can't calculate double interpolation for y: '".concat(params.y, "'"));
      }

      if (x1.x === x2.x) {
        var filter = function filter(i) {
          return i.x === x1.x;
        };

        var map = function map(i) {
          return {
            x: i.y,
            y: i.z
          };
        };

        return single_1.single(points.filter(filter).map(map))({
          x: params.y
        });
      }

      if (y1.y === y2.y) {
        var _filter = function _filter(i) {
          return i.y === y1.y;
        };

        var _map = function _map(i) {
          return {
            x: i.x,
            y: i.z
          };
        };

        return single_1.single(points.filter(_filter).map(_map))({
          x: params.x
        });
      }

      var z11 = points.find(function (i) {
        return i.x === x1.x && i.y === y1.y;
      });
      var z12 = points.find(function (i) {
        return i.x === x2.x && i.y === y1.y;
      });
      var z21 = points.find(function (i) {
        return i.x === x1.x && i.y === y2.y;
      });
      var z22 = points.find(function (i) {
        return i.x === x2.x && i.y === y2.y;
      });

      if (!z11 || !z12 || !z21 || !z22) {
        throw new Error("Can't calculate double interpolation for x: '".concat(params.x, "' and y: '").concat(params.y, "'"));
      }

      var p1 = (x2.x - params.x) * (y2.y - params.y) / ((x2.x - x1.x) * (y2.y - y1.y)) * z11.z;
      var p2 = (params.x - x1.x) * (y2.y - params.y) / ((x2.x - x1.x) * (y2.y - y1.y)) * z12.z;
      var p3 = (x2.x - params.x) * (params.y - y1.y) / ((x2.x - x1.x) * (y2.y - y1.y)) * z21.z;
      var p4 = (params.x - x1.x) * (params.y - y1.y) / ((x2.x - x1.x) * (y2.y - y1.y)) * z22.z;
      return p1 + p2 + p3 + p4;
    }

    if ('z' in params) {
      var _exports$format = exports.format(params, points),
          _exports$format2 = _slicedToArray(_exports$format, 2),
          c = _exports$format2[0],
          p = _exports$format2[1];

      var sortMin = function sortMin(a, b) {
        return b[0] - a[0];
      };

      var findMin = function findMin(i) {
        return i[0] <= c;
      };

      var min = p.sort(sortMin).find(findMin);

      var sortMax = function sortMax(a, b) {
        return a[0] - b[0];
      };

      var findMax = function findMax(i) {
        return i[0] >= c;
      };

      var max = p.sort(sortMax).find(findMax);

      if (!min || !max) {
        throw new Error("Can't calculate double interpolation");
      }

      var _p = p.filter(function (i) {
        return i[0] === min[0];
      });

      var _p2 = p.filter(function (i) {
        return i[0] === max[0];
      });

      var _map2 = function _map2(curr, i) {
        return {
          x: ((c - curr[0]) * (_p[i][2] - curr[2]) / (_p[i][0] - curr[0]) || 0) + curr[2],
          y: curr[1]
        };
      };

      return single_1.single(_p2.map(_map2))({
        x: params.z
      });
    }

    throw new Error("Can't calculate double interpolation");
  };
}

exports.double = double;